import { CCXMLTimeSlotDto, isNumber, TimeSlot, TimeSlotType } from '@contact/upgrade';

/**
 * we use uuid when retrieving campaign from campaign service and calling CampaignUtil.fromDto
 * we use timeslotUuid when retrieving appointment from bl and calling getCampaignContactsByAddress
 */
export class TimeSlotUtil {
  static fromDto(toConvert: CCXMLTimeSlotDto): TimeSlot {
    return {
      id: toConvert.uuid ? toConvert.uuid : toConvert.timeslotUuid,
      beginDate: isNumber(toConvert.beginDate) ? toConvert.beginDate : toConvert.beginDate.getTime(),
      endDate: isNumber(toConvert.endDate) ? toConvert.endDate : toConvert.endDate.getTime(),
      type: TimeSlotType[toConvert.timeSlotType],
      contactThreshold: toConvert.contactThreshold,
      contactCount: toConvert.contactCount || 0,
    } as TimeSlot;
  }
}
